
import TableList from "@components/templates/tablelist";
// import { HttpLogisticsList, HttpCancelLogisticsOne, HttpSubmitLogisticsOne, HttpAddressList, HttpUpdateLogistics } from "@/service/headlogistics";
import mixin from './mixin';
import {
    HttpGetPackage
} from '@/service/expresspackage';
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex,
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpGetPackage,

        showDetailModal (id) {
            this.modal = {
                show: true,
                showFooter: false,
                title: this.$t('fbb.expresspackage.package_detail',{defaultValue:'包裹详情'}),
                width: 800,
                id: id
            }
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query',{defaultValue:'查看'}),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        id: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "headlogiticsUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
            }
        },
        // getOperateNodeMap(row) {
        //     const { id, orderStatus } = row
        //     return [
        //         {
        //             label: '查看',
        //             show: true,
        //             params: id,
        //             operate: 'query'
        //         },
        //         {
        //             label: '编辑',
        //             show: (orderStatus == 10 || orderStatus == 0 || orderStatus == 2) && this.handleAuth('fbb.logisticsHead.create'),
        //             params: id,
        //             operate: 'edit'
        //         }, {
        //             label: '取消',
        //             show: (orderStatus == 10 || orderStatus == 0 || orderStatus == 1 || orderStatus == 2) && this.handleAuth('fbb.logisticsHead.cancel'),
        //             params: id,
        //             operate: 'cancel'
        //         },
        //         {
        //             label: '查看物流',
        //             show: true,
        //             params: id,
        //             operate: 'seelogistics'
        //         },]
        // },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSystemPortList', 'getCompanyList', 'getFilterDisabledWarehouse']),
        SearchsData() {
            // let widthStyle = 'width: 220px;'
            let style = 'width: 130px; margin-right: 20px;'
            return [
                {
                    label: this.$t('fbb.expresspackage.head_id',{defaultValue:'销售出库计划单号'}),
                    tag: 'vInput',
                    key: 'EQ_headId',
                    show: true,
                    style: style,
                },
                {
                    label: this.$t('fbb.expresspackage.sale_order_no',{defaultValue:'来源单号'}),
                    tag: 'vInput',
                    key: 'EQ_saleOrderNo',
                    show: true,
                    style: style,
                },
                {
                    label: this.$t('fbb.expresspackage.track_no',{defaultValue:'物流单号'}),
                    tag: 'vInput',
                    key: 'CN_trackNo',
                    show: true,
                    style: style,
                },
                {
                    label: this.$t('fbb.expresspackage.erp_sku',{defaultValue:'SKU'}),
                    tag: 'vInput',
                    key: 'EQ_erpSku',
                    style: style,
                    show: true,
                },
                // {
                //     label: "出库仓库",
                //     tag: 'Select',
                //     key: 'IN_orderStatus',
                //     options: this.getFilterDisabledWarehouse,
                //     props: {
                //         filterable: true,
                //         multiple: true
                //     },
                //     style: style,
                //     show: true,
                // },
                {
                    label: this.$t('fbb.expresspackage.logistic_status',{defaultValue:'物流状态'}),
                    tag: 'Select',
                    key: 'EQ_logisticStatus',
                    options: this.getLogisticStatus,
                    props: {
                        filterable: true,
                    },
                    style: style,
                    show: true,
                },
                {
                    label: this.$t("global.common.update_time",{defaultValue:'更新时间'}),
                    key: 'BT_updatedAt',
                    tag: 'vDatepicker',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: style,
                    show: true,
                },
            ]
        },
        columns() {
            return [{
                title: 'No',
                type: 'index',
                width: 40
            }, {
                title: this.$t('fbb.expresspackage.track_no',{defaultValue:'物流单号'}),
                key: 'trackNo',
                render: (h, { row }) => {
                    // return <a click={this.showDetailModal(row.id)}>{row.logisticStatus}</a>
                    return (
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.trackNo}</a>
                        </div>
                    )
                }
            },
            // {
            //     title: '异常状态',
            // },
            {
                title: this.$t('fbb.expresspackage.logistic_status',{defaultValue:'物流状态'}),
                render: (h, { row }) => {
                    let logisticStatus = this.getLogisticStatus.filter(item => {
                        return row.logisticStatus === item.value
                    })[0];
                    logisticStatus = logisticStatus.label ? logisticStatus.label : '--';
                    return <div>
                        <div>{logisticStatus}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.expresspackage.shipping_cost',{defaultValue:'预估运费'}),
                render: (h, { row }) => {
                    return (
                        <div>
                            {row.shippingCost} {row.shippingCostCurrency}
                        </div>
                    )
                }
            },
            {
                title: this.$t('fbb.expresspackage.head_id',{defaultValue:'销售出库计划单号'}),
                // key: 'saleOrderNo'
                key: 'headId'
            },
            {
                title: this.$t('fbb.expresspackage.sale_order_no',{defaultValue:'来源单号'}),
                key: 'saleOrderNo'
            },
            {
                title: this.$t('fbb.expresspackage.erp_sku',{defaultValue:'SKU'}),
                key: 'erpSku',
            },
            {
                title: this.$t('fbb.expresspackage.shiped_quantity',{defaultValue:'发运数量'}),
                key: 'shipedQuantity',
            },
            {
                title: this.$t('fbb.expresspackage.service_code',{defaultValue:'承运商'}),
                key: "serviceCode",
            },
            {
                title: this.$t('fbb.expresspackage.shipment_date',{defaultValue:'出库时间'}),
                key: 'shipmentDate'
            },
            {
                title: this.$t("global.common.update_time",{defaultValue:'更新时间'}),
                key: 'updatedAt',
            },
            ];
        },

    },
};
